import { defineStore } from 'pinia'

interface AuthState {
  user : {
    email: string
    id: number | null
  }
}

export const useAuthStore = defineStore('AuthStore', {
  state: (): AuthState => ({
    user : {
      email: '',
      id: null
    }
  }),
  getters: {
    isLoggedIn: (state) => state.user.email !==  ''
  }
})

export type AuthStore = ReturnType<typeof useAuthStore>
